import { REPORT_TYPE_REGISTRY } from '../../config/reportTypes';
import type { SiteRagReport } from '../../types/siteRag';
import { reportRevisionReferenceV1Schema } from '../../types/reportContractsV2';
import { advisoryFilteredDeliveryDecision, canBuildReportArtifacts, evaluateReportDelivery } from '../reportGeneration/evaluateReportDelivery';
import { SUMMARY_BUILDER_VERSION } from '../screeningSummary/vocabulary';
import { REPORT_SUMMARY_BUILDER_VERSION } from './types';

export type ReportSummaryView = 'screening-summary' | 'report-summary';
export function reportSummaryViewForType(type: unknown): ReportSummaryView {
  if (typeof type !== 'string' || !Object.hasOwn(REPORT_TYPE_REGISTRY, type)) throw new Error('Unknown report type.');
  return type === 'feasibility' ? 'screening-summary' : 'report-summary';
}
export function reportSummaryBuilderVersionForView(view: ReportSummaryView): string {
  if (view === 'screening-summary') return SUMMARY_BUILDER_VERSION;
  if (view === 'report-summary') return REPORT_SUMMARY_BUILDER_VERSION;
  throw new Error('Unknown summary view.');
}

/** Action visibility only; the ordinary artifact request/server still gate a new export. */
export function reportSummaryEligibility(report: SiteRagReport): { ok: true } | { ok: false; reason: string } {
  const reportType = report.reportType ?? 'feasibility';
  if (!Object.hasOwn(REPORT_TYPE_REGISTRY, reportType)) return { ok: false, reason: 'This report type has no saved summary view.' };
  if (report.generationTier === 'draft') return { ok: false, reason: 'Complete the report before creating a summary.' };
  const revision = reportRevisionReferenceV1Schema.safeParse(report.reportRevision);
  if (!revision.success) return { ok: false, reason: 'This historical report has no immutable revision for a summary.' };
  const decision = report._metadataOnly ? advisoryFilteredDeliveryDecision(revision.data.deliveryDecision)
    : evaluateReportDelivery({ report, authorization: 'authorized', bodyState: 'ready' });
  return canBuildReportArtifacts(report.pdfDelivery, decision) || advisoryFilteredDeliveryDecision(decision).canExport
    ? { ok: true } : { ok: false, reason: decision.reasons[0]?.message ?? 'This revision cannot create exports.' };
}
